import React from 'react'
import TextField from '../../../../Forms/TextField'

const HubImagesForm = () => {

  return (
    <div className="mt-1">
          <p>For all images, enter URL with a 'https://cdn.igrad.com/'/' domain, formatted as .webp. You can convert them here if needed: https://cloudconvert.com/jpg-to-webp.</p>

          <TextField
            label="Topics Image"
            inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
            placeholder="Enter URL with 'https://cdn.igrad.com/'/' domain"
            type="text"
            name="hubTopicsImage"
          />
          <TextField
            label="Courses Image"
            inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
            placeholder="Enter URL with 'https://cdn.igrad.com/'/' domain"
            type="text"
            name="hubCoursesImage"
          />
          <TextField
            label="Tools Image"
            inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
            placeholder="Enter URL with 'https://cdn.igrad.com/'/' domain"
            type="text"
            name="hubToolsImage"
          />
          <TextField
            label="Challenge Image"
            inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
            placeholder="Enter URL with 'https://cdn.igrad.com/'/' domain"
            type="text"
            name="hubChallengeImage"
          />
          <TextField
            label="Mindfulness Image"
            inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
            placeholder="Enter URL with 'https://cdn.igrad.com/'/' domain"
            type="text"
            name="hubMindfulnessImage"
          />
          

      
    </div>
  )
}

export default HubImagesForm
